
<div
  :class="classes(n())"
  role="region"
  aria-label="表单预览"
>
  <!-- 头部区域（条件渲染） -->
  <div
    v-if="showHeader"
    :class="n('header')"
    role="group"
    aria-label="主要信息"
  >
    <span :class="n('header-key')">{{ headerKey }}</span>
    <div :class="n('header-value')">
      <slot name="headerValue" />
    </div>
  </div>

  <!-- 中间内容区域（必选） -->
  <div
    :class="n('content')"
    role="list"
    aria-label="详细信息列表"
  >
    <div
      v-for="(item, index) in items"
      :key="index"
      :class="getItemClasses(index)"
      role="listitem"
      :aria-label="`${item.key}: ${item.value}`"
    >
      <span :class="n('item-key')">{{ item.key }}</span>
      <div :class="getValueClasses(item.valueType, item.displayType)">
        <slot
          name="item-value"
          :item="item"
          :index="index"
        >
          {{ item.value }}
        </slot>
      </div>
    </div>
  </div>

  <!-- 底部按钮区域（条件渲染） -->
  <div
    v-if="showFooter"
    :class="n('footer')"
    role="group"
    aria-label="操作按钮"
  >
    <div
      v-for="(button, index) in buttons"
      :key="index"
      :class="getButtonClasses(button.type)"
      type="button"
      @click="handleButtonClick(index, button)"
      @keydown.enter="handleButtonClick(index, button)"
      @keydown.space.prevent="handleButtonClick(index, button)"
    >
      {{ button.text }}
    </div>
  </div>
</div>
